import React from "react";
import ForwardIcon from "../../../UI/IconComponents/ForwardIcon";
import Wrapper from "../../../UI/Wrapper/Wrapper";
import hero from "./images/hero.png";
import "./_Main.scss";

const TopSection = () => {
  return (
    <div className="caseStudy__jazzy-top-section">
      <div className="hero-container">
        <img src={hero} alt="Jazzy's Burger" />
      </div>
      <Wrapper className="jazzy-top-section__lower">
        <div>
          <span>
            <h6>Overview</h6>
            <p>
              Awa Digital built and runs the ordering software for Jazzy&apos;s
              Burger: mobile apps, web ordering, payments, and admin across
              multiple cities in Nigeria. In production since 2022.
            </p>
          </span>
          <span>
            <h6>What we built</h6>
            <p>
              Consumer ordering and checkout, branch routing, multi-gateway
              payments, and operational tooling for catalogue, pricing, and
              fulfilment at scale.
            </p>
          </span>
          <div style={{ margin: 0, width: "100%", position: "relative" }}>
            <a
              className="jazzy-top-section__lower-launch-btn"
              href="https://jazzysburger.com"
              target="_blank"
              rel="noreferrer"
            >
              <p>Visit site</p>
              <ForwardIcon size={35} hoverColor={"rgb(0, 186, 128)"} />
            </a>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default TopSection;
